import GLightbox from 'glightbox';
import Tipso from 'tipso';
import SimpleBar from 'simplebar';
import Swiper from 'swiper/bundle';
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
gsap.registerPlugin(ScrollTrigger);

$(function () {
    $.fn.initializeDropdown = function (options) {
        var settings = $.extend(
            {
                onOptionSelect: null,
            },
            options
        );

        return this.each(function () {
            var $dropdown = $(this);
            var $selected = $dropdown.find('.selected');
            var $options = $dropdown.find('.options');
            var $optionsList = $dropdown.find('.options ul');
            var $listItems = $optionsList.find('li');

            // Toggle dropdown open/close with slide effect
            $selected.on('click', function () {
                toggleDropdown();
            });

            // Update selected value and hide options when clicking on an option
            $listItems.on('click', function () {
                selectOption($(this));
            });

            // Keyboard navigation
            $dropdown.on('keydown', function (e) {
                var isOpen = $dropdown.hasClass('open');
                switch (e.key) {
                    case 'ArrowDown':
                        e.preventDefault();
                        if (!isOpen) {
                            openDropdown();
                        } else {
                            focusNextOption();
                        }
                        break;
                    case 'ArrowUp':
                        e.preventDefault();
                        if (!isOpen) {
                            openDropdown();
                        } else {
                            focusPrevOption();
                        }
                        break;
                    case 'Enter':
                    case ' ':
                        e.preventDefault();
                        if (isOpen) {
                            selectOption($(document.activeElement));
                        } else {
                            openDropdown();
                        }
                        break;
                    case 'Escape':
                        closeDropdown();
                        break;
                }
            });

            // Close dropdown if clicked outside
            $(document).on('click', function (e) {
                if (!$dropdown.is(e.target) && $dropdown.has(e.target).length === 0) {
                    closeDropdown();
                }
            });

            function toggleDropdown() {
                if ($dropdown.hasClass('open')) {
                    closeDropdown();
                } else {
                    openDropdown();
                }
            }

            function openDropdown() {
                $options.slideDown();
                $dropdown.addClass('open').attr('aria-expanded', 'true');
                $listItems.first().focus();
            }

            function closeDropdown() {
                $options.slideUp();
                $dropdown.removeClass('open').attr('aria-expanded', 'false');
                $selected.focus();
            }

            function selectOption($option) {
                var selected_text = $option.text().trim();
                var selected_value = $option.attr('data-value');
                $selected.text(selected_text);

                // Update aria-selected attributes
                $listItems.attr('aria-selected', 'false');
                $option.attr('aria-selected', 'true');

                // Add active class to clicked li and remove from others
                $listItems.removeClass('active');
                $option.addClass('active');

                if (settings.onOptionSelect) {
                    settings.onOptionSelect.call($dropdown[0], selected_text, selected_value);
                }

                closeDropdown();
            }

            function focusNextOption() {
                var $focused = $(document.activeElement);
                var $next = $focused.next();
                if ($next.length) {
                    $next.focus();
                }
            }

            function focusPrevOption() {
                var $focused = $(document.activeElement);
                var $prev = $focused.prev();
                if ($prev.length) {
                    $prev.focus();
                }
            }
        });
    };

    // Rename gridSlider to mobileSlider
    $.fn.mobileSlider = function () {
        // Only run on tablet and mobile
        if (window.innerWidth > 1024) { return this; }

        this.each(function () {
            var $original = $(this);

            // Skip if already processed
            if ($original.hasClass('swiper-initialized') || $original.find('.swiper').length) { return; }

            // If .grid-slider is a <ul>, convert it to <div>
            if ($original.is('ul')) {
                var $div = $('<div></div>').addClass($original.attr('class')).attr('id', $original.attr('id'));
                // Replace <li> with <div>
                $original.children('li').each(function () {
                    var $li = $(this);
                    var $divChild = $('<div></div>')
                        .addClass($li.attr('class'))
                        .attr('id', $li.attr('id'))
                        .html($li.html());
                    $div.append($divChild);
                });
                $original.replaceWith($div);
                $original = $div;
            } else {
                // If not <ul>, but has <li> children, convert them to <div>
                $original.children('li').each(function () {
                    var $li = $(this);
                    var $divChild = $('<div></div>')
                        .addClass($li.attr('class'))
                        .attr('id', $li.attr('id'))
                        .html($li.html());
                    $li.replaceWith($divChild);
                });
            }

            // Create a clean <div class="mobile-slider">
            var $cleanSlider = $('<div class="mobile-slider"></div>');

            // Build Swiper DOM
            var $swiper = $('<div class="swiper"></div>');
            var $wrapper = $('<div class="swiper-wrapper"></div>');

            // Wrap each direct child of .grid-slider in a swiper-slide
            $original.children().each(function () {
                var $child = $(this).detach();
                var $slide = $('<div class="swiper-slide"></div>').append($child);
                $wrapper.append($slide);
            });

            // Build pagination controls
            var $pagination = $('<div class="swiper-pagination is-style-default"></div>');
            var $controls = $('<div class="swiper-controls"></div>').append($pagination);
            var $controlsWrapper = $('<div class="swiper-controls-wrapper"></div>').append($controls);

            // Assemble final DOM
            $swiper.append($wrapper).append($controlsWrapper);
            $cleanSlider.append($swiper);

            // Append the clean slider inside the original block
            $original.append($cleanSlider);

            // Initialize Swiper
            new Swiper($swiper[0], {
                slidesPerView: 1,
                autoHeight: true,
                spaceBetween: 32,
                loop: false,
                pagination: {
                    el: $pagination[0],
                    clickable: true,
                },
            });
        });

        return this;
    };

    fixed_header();
    $('body').addClass('animate-body');
    $('.grid-slider').mobileSlider();
    $('.video-gallery-block.multi-video .preview').mobileSlider();

    $('.dropdown-menu .wp-block-navigation-item.has-child > a').on('click', function (e) {
        $(this).parent().toggleClass('open');
    });

    $(document).on('click', '.facetwp-page', function (e) {
        // Exclude the pages with the 'active' or 'dots' classes
        // Get the .custom-as element
        var $customAs = $('.custom-as');

        // Ensure .custom-as exists on the page
        if ($customAs.length) {
            // Calculate the offset position to scroll to (20% from the top of the screen)
            var scrollToPosition = $customAs.offset().top - $(window).height() * 0.2;

            // Scroll smoothly to the calculated position
            $('html, body').animate(
                {
                    scrollTop: scrollToPosition,
                },
                600
            ); // You can adjust the speed (600ms) as needed
        }
    });

    // Responsive Menu Button Click
    $('.wp-block-navigation__responsive-container-open').on('click', function (e) {
        $('body').addClass('menu-open');
    });

    $('.wp-block-navigation__responsive-container-close').on('click', function (e) {
        $('body').removeClass('menu-open');
    });

    $('a[href="#subscribe"]').on('click', function (e) {
        $('.wp-block-navigation__responsive-container-close').trigger('click');
    });

    // Megu Menu Accordions
    $('.wp-block-navigation-item.has-child > a').on('click', function (e) {
        var $container = $(this).closest('.wp-block-navigation__responsive-container');
        var $parent = $(this).closest('.wp-block-navigation-item');
        var $navColParent = $parent.closest('.navigation-column');
        var $submenu = $parent.find('> .wp-block-navigation__submenu-container');

        if ($submenu.length) {
            e.preventDefault(); // prevent default link behavior

            if (!$container.hasClass('is-menu-open')) {
                $('.wp-block-navigation-item.active')
                    .not($parent)
                    .removeClass('active')
                    .find('> .wp-block-navigation__submenu-container')
                    .slideUp(300);
            }

            if ($container.hasClass('is-menu-open') || $navColParent.length) {
                var isActive = $parent.hasClass('active');

                if (isActive) {
                    $submenu.stop(true, true).slideUp(300);
                } else {
                    $submenu.stop(true, true).slideDown(300);
                }

                $parent.toggleClass('active');
            }
        }
    });

    // GLightbox instance for modals
    var modalLightbox = GLightbox({
        selector: '.glightbox-modal', // Target modal elements
        touchNavigation: true,
        loop: false,
        draggable: false,
        zoomable: true,
        autoplayVideos: false, // No autoplay needed for modals
        closeOnOutsideClick: true,
        height: 'auto',
        openEffect: 'fade',
        closeEffect: 'fade',
        closeButton: false, // Disable close button for modals
        plyr: null, // No Plyr config needed for modals
    });

    /*
    $('section.has-background').each(function () {
        const $section = $(this);
        // Find the first class that matches has-*-background-color
        const colorClass = ($section.attr('class').match(/has-[\w-]+-background-color/g) || [])[0];

        ScrollTrigger.create({
            trigger: $section[0],
            start: 'top center',
            end: 'bottom center',
            onEnter: () => {
                if (colorClass) $('body').addClass(colorClass);
                $section.addClass('animate-in');
            },
            onEnterBack: () => {
                if (colorClass) $('body').addClass(colorClass);
                $section.addClass('animate-in');
            },
            onLeave: () => {
                if (colorClass) $('body').removeClass(colorClass);
                $section.removeClass('animate-in');
            },
            onLeaveBack: () => {
                if (colorClass) $('body').removeClass(colorClass);
                $section.removeClass('animate-in');
            },
        });
    });
    */

    // Event handlers for modal lightbox
    modalLightbox.on('open', function () {
        // Apply SimpleBar to the modal content
        var modalContent = $('.modal .component-text');
        if (modalContent.length) {
            modalContent.each(function () {
                new SimpleBar(this, { autoHide: false });
            });
        }
    });

    modalLightbox.on('close', function () {
        var modalContent = $('.modal .component-text');
        if (modalContent.length) {
            modalContent.each(function () {
                var instance = SimpleBar.instances.get(this);
                if (instance) {
                    instance.unMount();
                }
            });
        }
    });

    $('.glightbox-modal').on('click', function (e) {
        e.preventDefault();

        // Get the href attribute of the clicked element
        var targetHref = $(this).attr('href');

        // Set the elements for GLightbox
        modalLightbox.setElements([{ href: targetHref }]);

        // Open the lightbox
        modalLightbox.open();
    });

    if ($('.module-incident-map').length > 0) {
        $('.has-incident').each(function () {
            var $this = $(this);

            $this.on('click', function (e) {
                e.preventDefault();
                var id = $this.attr('id');
                $('a[href="#' + id + '-modal"]').trigger('click');
            });
        });

        $('.filter .dropdown').initializeDropdown({
            onOptionSelect: function (text, value) {
                $('a[href="#' + value + '-modal"]').trigger('click');
            },
        });

        $('.has-incident').tipso({
            showArrow: false,
            position: 'top',
            delay: 0,
            onBeforeShow: function (element, tipso) {
                // Continue to track the mouse and update tooltip position
                $(document).on('mousemove', function (e) {
                    var mouseX = e.pageX;
                    var mouseY = e.pageY;

                    // Calculate the position of the tooltip based on the mouse position
                    var tooltipOffsetX = -50; // Adjust the X offset as needed
                    var tooltipOffsetY = -40; // Adjust the Y offset as needed

                    // Get the tipso bubble
                    var bubble = $('.tipso_bubble');

                    // Update the bubble position
                    bubble.css({
                        top: mouseY + tooltipOffsetY + 'px',
                        left: mouseX + tooltipOffsetX + 'px',
                    });
                });
            },
            onShow: function (element, tipso) {
                // Capture the event and get mouse position

                $(document).on('mousemove', function (e) {
                    var mouseX = e.pageX;
                    var mouseY = e.pageY;

                    // Calculate the position of the tooltip based on the mouse position
                    var tooltipOffsetX = -50; // Offset the tooltip by 10px from the cursor
                    var tooltipOffsetY = -40;

                    // Get the tipso bubble
                    var bubble = $('.tipso_bubble');

                    // Update the bubble position
                    bubble.css({
                        top: mouseY + tooltipOffsetY + 'px',
                        left: mouseX + tooltipOffsetX + 'px',
                    });
                });
            },
            onHide: function (element, tipso) {
                // Remove the mousemove event listener to prevent it from running unnecessarily
                $(document).off('mousemove');
            },
        });
    }

    // GSAP animate .wp-block-image.has-animation when halfway in view (down and up)
    $('.wp-block-image.has-animation,.wp-block-video.has-animation').each(function () {
        var el = this;
        ScrollTrigger.create({
            trigger: el,
            start: 'top 80%',
            end: 'bottom 20%', // Animation stays active until the bottom of the element passes 20% from top of viewport
            onEnter: function () {
                $(el).addClass('is-animated');
            },
            onEnterBack: function () {
                $(el).addClass('is-animated');
            },
            onLeave: function () {
                $(el).removeClass('is-animated');
            },
            onLeaveBack: function () {
                $(el).removeClass('is-animated');
            },
        });
    });

    function fixed_header() {
        var $window = $(window);
        var $header = $('header.wp-block-template-part');
        var $bottomHeader = $header.find('.bottom-header');
        var triggerPoint = $bottomHeader.offset().top;
        function updateHeaderPosition() {
            if ($window.scrollTop() >= triggerPoint) {
                $header.addClass('is-fixed');
            } else {
                $header.removeClass('is-fixed');
            }
        }
        $window.on('scroll', updateHeaderPosition);
    }

    $(document).on(
        'click',
        '.trp-block-container .trp_language_switcher_shortcode .trp-language-switcher.trp-language-switcher-container .trp-ls-shortcode-current-language',
        function (e) {
            if (!$('html').hasClass('has-modal-open')) {
                $('#modal-1').addClass('has-modal-open');
                $('#modal-1').addClass('is-menu-open');
                $('html').addClass('has-modal-open');
                $('body').addClass('menu-open');
                setTimeout(function () {
                    $('.trp-block-container .trp-ls-shortcode-language').toggleClass('active-language-dropwdown');
                }, '100');
            } else {
                $('.trp-block-container .trp-ls-shortcode-language').toggleClass('active-language-dropwdown');
            }
        }
    );

    $(document).on('click', '.wp-block-navigation__responsive-container-close', function (e) {
        if ($('html').hasClass('has-modal-open')) {
            $('#modal-1').removeClass('has-modal-open');
            $('#modal-1').removeClass('is-menu-open');
            $('html').removeClass('has-modal-open');
            $('body').removeClass('menu-open');
            $('.trp-block-container .trp-ls-shortcode-language').removeClass('active-language-dropwdown');
        }
    });

    $('#modal-1').removeAttr('data-wp-on-async--focusout');
});
